import { Alert, Button, Modal } from '@ksyos/design-system';
import { getSelectedLanguage } from '@frontend/translate';

interface HasActiveRequestsProps {
    isOpen: boolean;
    onClose: () => void;
}

export function HasActiveRequestsModal(props: Readonly<HasActiveRequestsProps>) {
    const translate = getSelectedLanguage();

    return (
        <Modal
            isOpen={props.isOpen}
            onClose={() => props.onClose()}
            size={'medium'}
        >
            <Modal.Header>{translate.accountDeactivation.hasActiveRequestsTitle}</Modal.Header>
            <Modal.Body>
                <Alert
                    appearance="warning"
                    style={{ whiteSpace: 'preserve-spaces' }}
                >
                    {translate.accountDeactivation.hasActiveRequestsGp}
                </Alert>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={() => props.onClose()}>{translate.common.closeShort}</Button>
            </Modal.Footer>
        </Modal>
    );
}
